import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import {
  getMessageTemplate,
  MessageTemplateName,
} from "./messagesApi";

type SliceState = {
  status: "idle" | "pending" | "succeeded" | "failed";
  error: string | null;
};

const initialState: SliceState = {
  status: "idle",
  error: null,
};

export const fetchTalentRejectedDefaultMessageTemplate = createAsyncThunk<
  string,
  { bundleId?: string; jobAdId?: string },
  { state: RootState }
>(
  "messageTemplates/fetchTalentRejectedDefaultMessageTemplate",
  async (params, { requestId }) => {
    const response = await getMessageTemplate(
      {
        name: MessageTemplateName.TalentRejection,
        ...params,
      },
      { requestId },
    );
    return response.message;
  },
);

const messageTemplatesSlice = createSlice({
  name: "messageTemplates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTalentRejectedDefaultMessageTemplate.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(fetchTalentRejectedDefaultMessageTemplate.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(fetchTalentRejectedDefaultMessageTemplate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message ?? null;
      });
  },
});

export const messageTemplatesReducer = messageTemplatesSlice.reducer;
